<template>
  <v-container>
    <v-layout
      row
      pt-10
    >
      <v-flex
        xs12
        sm6
        offset-sm3
      >
        <h2
          class="primary--text"
        >
          Edit {{ title }}
        </h2>
        <v-btn
          to="/iabf/admin/pieces"
        >
          Back to Showcase Lineup
        </v-btn>
        <br />
        <v-dialog
          v-model="dialog"
          width="500"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="red"
              dark
              v-bind="attrs"
              v-on="on"
            >
              - Delete piece
            </v-btn>
          </template>

          <v-card>
            <v-card-title class="text-h5 grey lighten-2">
              Are you sure?
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <p>Are you sure you'd like to delete this piece?</p>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                text
                @click="deletePiece()"
              >
                Yes, Delete
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>
    <v-layout
      row
      pt-10
    >
      <v-flex
        xs12
      >
        <form @submit.prevent="onUpdatePiece">
          <v-layout
            row
          >
            <v-flex
              xs12
              sm6
              offset-sm3
            >
              <v-text-field
                id="title"
                v-model="title"
                name="title"
                label="Variation or Song Title"
                required
              />
              <v-text-field
                id="song-artist"
                v-model="songArtist"
                name="song-artist"
                label="Song Artist"
                required
              />
              <v-select
                id="pieceType"
                v-model="pieceType"
                name="pieceType"
                label="pieceType"
                :items="pieceTypes"
                required
              />
              <v-select
                id="competition"
                v-model="competition"
                name="competition"
                label="Competition"
                :items="competitionDivisions"
              />
              <v-checkbox
                id="musicReceived"
                v-model="musicReceived"
                name="musicReceived"
                label="Music Received"
              />
              <v-text-field
                v-if="musicReceived === true"
                id="lengthInSeconds"
                v-model="lengthInSeconds"
                name="lengthInSeconds"
                label="Length (In Seconds)"
                type="number"
              />
              <v-select
                id="groupSize"
                v-model="groupSize"
                name="groupSize"
                label="groupSize"
                :items="groupSizes"
                required
              />
              <p
                v-if="groupSize && groupSize !== 'Solo'"
                class="caption grey--text"
                style="margin-top: -4px; margin-bottom: 12px;"
              >
                Music is split evenly among the dancers on this piece toward each person’s 5½ minutes.
              </p>
              <v-select
                id="dancer1"
                v-model="dancer1"
                name="dancer1"
                label="dancer1"
                item-text="name"
                item-value="id"
                :items="allDancers"
                required
              />
              <v-select
                v-if="groupSize === 'Duet/Pas de Deux' || groupSize === 'Trio' || groupSize === '4-12 Dancers'"
                id="dancer2"
                v-model="dancer2"
                name="dancer2"
                label="dancer2"
                item-text="name"
                item-value="id"
                :items="allDancers"
              />
              <v-select
                v-if="groupSize === 'Trio' || groupSize === '4-12 Dancers'"
                id="dancer3"
                v-model="dancer3"
                name="dancer3"
                label="dancer3"
                item-text="name"
                item-value="id"
                :items="allDancers"
              />
              <v-select
                v-if="groupSize === '4-12 Dancers'"
                id="dancer4"
                v-model="dancer4"
                name="dancer4"
                label="dancer4"
                item-text="name"
                item-value="id"
                :items="allDancers"
              />
              <v-select
                v-if="groupSize === '4-12 Dancers'"
                id="dancer5"
                v-model="dancer5"
                name="dancer5"
                label="dancer5"
                item-text="name"
                item-value="id"
                :items="allDancers"
              />
              <v-select
                v-if="groupSize === '4-12 Dancers'"
                id="dancer6"
                v-model="dancer6"
                name="dancer6"
                label="dancer6"
                item-text="name"
                item-value="id"
                :items="allDancers"
              />
              <v-select
                v-if="groupSize === '4-12 Dancers'"
                id="dancer7"
                v-model="dancer7"
                name="dancer7"
                label="dancer7"
                item-text="name"
                item-value="id"
                :items="allDancers"
              />
              <v-select
                v-if="groupSize === '4-12 Dancers'"
                id="dancer8"
                v-model="dancer8"
                name="dancer8"
                label="dancer8"
                item-text="name"
                item-value="id"
                :items="allDancers"
              />
              <v-select
                v-if="groupSize === '4-12 Dancers'"
                id="dancer9"
                v-model="dancer9"
                name="dancer9"
                label="dancer9"
                item-text="name"
                item-value="id"
                :items="allDancers"
              />
              <v-select
                v-if="groupSize === '4-12 Dancers'"
                id="dancer10"
                v-model="dancer10"
                name="dancer10"
                label="dancer10"
                item-text="name"
                item-value="id"
                :items="allDancers"
              />
              <v-select
                v-if="groupSize === '4-12 Dancers'"
                id="dancer11"
                v-model="dancer11"
                name="dancer11"
                label="dancer11"
                item-text="name"
                item-value="id"
                :items="allDancers"
              />
              <v-select
                v-if="groupSize === '4-12 Dancers'"
                id="dancer12"
                v-model="dancer12"
                name="dancer12"
                label="dancer12"
                item-text="name"
                item-value="id"
                :items="allDancers"
              />
              <div v-if="dancerNames.length > 0" style="margin: 16px 0;">
                <label style="font-weight: 600; font-size: 14px; color: rgba(0,0,0,.6);">Competition Registered</label>
                <v-checkbox
                  v-for="d in dancerNames"
                  :key="d.id"
                  v-model="d.competitionRegistered"
                  :label="d.name"
                  hide-details
                  dense
                  @change="onToggleCompetitionRegistered(d)"
                />
              </div>
              <v-text-field
                id="programDancer"
                v-model="programDancer"
                name="programDancer"
                label="Dancer Name(s) for the Program"
              />
              <v-text-field
                id="programTeacher"
                v-model="programTeacher"
                name="programTeacher"
                label="Teacher/Choreographer Name for the Program"
              />
              <v-text-field
                id="programTitle"
                v-model="programTitle"
                name="programTitle"
                label="Title for the Program"
              />
              <v-select
                v-model="showcaseBlock"
                :items="showcaseBlockOptions"
                label="Showcase Solo Block (dancer preference)"
                clearable
              />
              <v-select
                v-model="showcasePlacement"
                :items="showcasePlacementOptions"
                label="Placement within block (dancer preference)"
                clearable
              />
              <v-text-field
                v-model="musicUrl"
                label="Music URL (mp3)"
                hint="Public mp3 URL. Dancers upload via the dashboard; paste manually here for fixups, or click Remove music to reset this piece."
                persistent-hint
                clearable
              />
              <v-text-field
                v-if="musicUrl"
                v-model="musicFileName"
                label="Music file name (display only)"
                clearable
              />
              <audio v-if="musicUrl" :src="musicUrl" controls style="width: 100%; margin: 8px 0 4px;" />
              <v-btn
                v-if="musicUrl || musicFileName"
                small
                outlined
                color="error"
                :loading="removingMusic"
                class="mb-3"
                @click="onRemoveMusic"
              >
                Remove music
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout
            row
            pt-5
          >
            <v-flex
              xs12
              sm6
              offset-sm3
            >
              <p
                v-if="saveError"
                class="error--text"
                role="alert"
                style="margin-bottom: 12px;"
              >
                {{ saveError }}
              </p>
              <v-btn
                class="primary"
                :disabled="!formIsValid || saving"
                :loading="saving"
                type="submit"
              >
                Update Piece
              </v-btn>
            </v-flex>
          </v-layout>
        </form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import iabfAdminMixin from '@/utils/iabf-admin-mixin'
import { assertStageTimeOk } from '@/utils/iabf-stage-time'
import { db, storage } from '../../firebase'

export default {
  mixins: [iabfAdminMixin],
    props: ['id'],
    data () {
      return {
        dialog: false,
        saveError: '',
        saving: false,
        pieceTypes: ['Classical Variation', 'Original Ballet Choreography', 'Contemporary/Lyrical Ballet', 'Jazz'],
        groupSizes: ['Solo', 'Duet/Pas de Deux', 'Trio', '4-12 Dancers'],
        allDancers: [],
        dancerNames: [],
        title: '',
        songArtist: '',
        programDancer: '',
        programTeacher: '',
        programTitle: '',
        musicReceived: false,
        lengthInSeconds: '',
        competitionDivisions: ['None', 'Beginner - Classical Variations', 'Beginner - Original Ballet, Lyrical, Contemporary, Jazz', 'Advanced - Classical Variations', 'Advanced - Original Ballet, Lyrical, Contemporary, Jazz'],
        pieceType: '',
        groupSize: '',
        dancer1: '',
        dancer2: '',
        dancer3: '',
        dancer4: '',
        dancer5: '',
        dancer6: '',
        dancer7: '',
        dancer8: '',
        dancer9: '',
        dancer10: '',
        dancer11: '',
        dancer12: '',
        showcaseBlock: null,
        showcasePlacement: null,
        musicUrl: '',
        musicFileName: '',
        removingMusic: false,
        showcaseBlockOptions: [
          { text: 'Solo Block AA (opening, before Alice in Wonderland)', value: 'AA' },
          { text: 'Solo Block A (after Alice in Wonderland)', value: 'A' },
          { text: 'Solo Block B (after Becoming)', value: 'B' },
          { text: 'Solo Block C (after Waltz of the Hours)', value: 'C' },
          { text: 'Solo Block D (after Le Jazz Hot)', value: 'D' }
        ],
        showcasePlacementOptions: [
          { text: 'Beginning of block', value: 'beginning' },
          { text: 'Middle of block', value: 'middle' },
          { text: 'End of block', value: 'end' }
        ]
      }
    },
    computed: {
      currentIABFPiece () {
        return this.$store.getters.currentIABFPiece
      },
      formIsValid () {
        return this.title !== '' && this.songArtist !== '' && this.pieceType !== '' && this.groupSize !== '' && this.dancer1 !== ''
      }
    },
    created () {
      this.$store.dispatch('loadIABFPiece', this.id).then(() => {
        const piece = this.currentIABFPiece
        if (!piece) {
          return
        }
        const dancers = Array.isArray(piece.dancers) ? piece.dancers : []
        this.title = piece.title || ''
        this.songArtist = piece.songArtist || ''
        this.programDancer = piece.programDancer || ''
        this.programTeacher = piece.programTeacher || ''
        this.programTitle = piece.programTitle || ''
        this.musicReceived = piece.musicReceived
        this.lengthInSeconds = piece.lengthInSeconds
        this.pieceType = piece.pieceType || ''
        this.groupSize = piece.groupSize || ''
        this.dancer1 = dancers[0] || ''
        this.dancer2 = dancers[1] || ''
        this.dancer3 = dancers[2] || ''
        this.dancer4 = dancers[3] || ''
        this.dancer5 = dancers[4] || ''
        this.dancer6 = dancers[5] || ''
        this.dancer7 = dancers[6] || ''
        this.dancer8 = dancers[7] || ''
        this.dancer9 = dancers[8] || ''
        this.dancer10 = dancers[9] || ''
        this.dancer11 = dancers[10] || ''
        this.dancer12 = dancers[11] || ''
        this.competition = piece.competition || 'None'
        this.showcaseBlock = piece.showcaseBlock || null
        this.showcasePlacement = piece.showcasePlacement || null
        this.musicUrl = piece.musicUrl || ''
        this.musicFileName = piece.musicFileName || ''
      })
      this.$store.dispatch('loadIABFDancers').then(() => {
        const loadedDancers = this.$store.getters.loadedIABFDancers
        loadedDancers.forEach(dancer => {
          this.allDancers.push({
            id: dancer.id,
            name: dancer.firstName + ' ' + dancer.lastName
          })
        })
        this.allDancers.sort((a, b) => {
          if (a.name < b.name) {
            return -1
          }
          if (a.name > b.name) {
            return 1
          }
          return 0
        })
        // Build dancerNames for competition checkboxes
        if (this.currentIABFPiece && this.currentIABFPiece.dancers) {
          this.dancerNames = this.currentIABFPiece.dancers
            .filter(id => !!id)
            .map(id => {
              const found = loadedDancers.find(d => d.id === id)
              return {
                id: id,
                name: found ? found.firstName + ' ' + found.lastName : id,
                competitionRegistered: found ? !!found.competitionRegistered : false
              }
            })
        }
      })
    },
    methods: {
      async onRemoveMusic () {
        // eslint-disable-next-line no-alert
        if (!window.confirm('Remove the music from this piece? This also marks "music received" as false and clears the length.')) return
        this.removingMusic = true
        try {
          // Best-effort: delete the file from Cloud Storage if the URL is one
          // we recognize (Firebase download URL or storage.googleapis.com path).
          if (this.musicUrl) {
            const path = this.storagePathFromUrl(this.musicUrl)
            if (path) {
              try { await storage.ref(path).delete() } catch (e) {
                console.warn('Could not delete storage file (continuing anyway):', e)
              }
            }
          }
          await db.collection(this.IABF.pieces).doc(this.id).update({
            musicUrl: '',
            musicFileName: '',
            musicReceived: false,
            lengthInSeconds: ''
          })
          this.musicUrl = ''
          this.musicFileName = ''
          this.musicReceived = false
          this.lengthInSeconds = ''
        } catch (e) {
          console.error('Remove music failed:', e)
          // eslint-disable-next-line no-alert
          window.alert('Could not remove the music. ' + (e.message || ''))
        }
        this.removingMusic = false
      },
      storagePathFromUrl (url) {
        if (!url) return null
        // https://firebasestorage.googleapis.com/v0/b/{bucket}/o/{encodedPath}?alt=media…
        const fb = url.match(/firebasestorage\.googleapis\.com\/v0\/b\/[^/]+\/o\/([^?]+)/)
        if (fb) return decodeURIComponent(fb[1])
        // https://storage.googleapis.com/{bucket}/{path}
        const gs = url.match(/storage\.googleapis\.com\/[^/]+\/(.+)$/)
        if (gs) return decodeURIComponent(gs[1])
        return null
      },
      formDancerIds () {
        return [
          this.dancer1, this.dancer2, this.dancer3, this.dancer4, this.dancer5, this.dancer6,
          this.dancer7, this.dancer8, this.dancer9, this.dancer10, this.dancer11, this.dancer12
        ].filter(Boolean)
      },
      dancerNameForId (id) {
        const found = this.allDancers.find(d => d.id === id)
        return found ? found.name : ''
      },
      async yearPiecesForValidation () {
        if (this._yearPieces && this._yearPieces.length) {
          return this._yearPieces
        }
        const snap = await db.collection(this.IABF.pieces).get()
        this._yearPieces = snap.docs.map((doc) => ({ id: doc.id, ...(doc.data() || {}) }))
        return this._yearPieces
      },
      computeNamedDancers () {
        const ids = this.formDancerIds()
        const names = ids
          .map(id => (this.allDancers.find(d => d.id === id) || {}).name)
          .filter(Boolean)
        // Sort alphabetically by first name so the program credit reads
        // consistently regardless of which dancer slot was filled first.
        names.sort((a, b) => (a.split(' ')[0] || '').localeCompare(b.split(' ')[0] || ''))
        return names.join(', ')
      },
      onToggleCompetitionRegistered (dancer) {
        db.collection(this.IABF.dancers).doc(dancer.id).update({
          competitionRegistered: dancer.competitionRegistered
        })
      },
      deletePiece () {
        this.$store.dispatch('deleteIABFPiece', this.id)
        this.$router.push('/iabf/admin/pieces')
      },
      async onUpdatePiece () {
        if (!this.formIsValid) {
          return
        }
        this.saveError = ''
        this.saving = true
        try {
          const allPieces = await this.yearPiecesForValidation()
          const check = assertStageTimeOk({
            allPieces,
            proposedPiece: {
              id: this.id,
              dancers: this.formDancerIds(),
              lengthInSeconds: this.lengthInSeconds
            },
            nameForId: (id) => this.dancerNameForId(id)
          })
          if (!check.ok) {
            this.saveError = check.error
            this.saving = false
            return
          }
          const pieceData = {
            id: this.id,
            title: this.title,
            songArtist: this.songArtist,
            programDancer: this.programDancer,
            programTeacher: this.programTeacher,
            programTitle: this.programTitle,
            musicReceived: this.musicReceived,
            lengthInSeconds: this.lengthInSeconds,
            pieceType: this.pieceType,
            groupSize: this.groupSize,
            dancer1: this.dancer1,
            dancer2: this.dancer2,
            dancer3: this.dancer3,
            dancer4: this.dancer4,
            dancer5: this.dancer5,
            dancer6: this.dancer6,
            dancer7: this.dancer7,
            dancer8: this.dancer8,
            dancer9: this.dancer9,
            dancer10: this.dancer10,
            dancer11: this.dancer11,
            dancer12: this.dancer12,
            competition: this.competition,
            showcaseBlock: this.showcaseBlock || null,
            showcasePlacement: this.showcasePlacement || null,
            namedDancers: this.computeNamedDancers(),
            musicUrl: this.musicUrl || '',
            musicFileName: this.musicFileName || ''
          }
          await this.$store.dispatch('updateIABFPiece', pieceData)
          this.$router.push('/iabf/admin/pieces')
        } catch (e) {
          this.saveError = (e && e.message) || 'Could not save this piece.'
        }
        this.saving = false
      }
    }
  }
</script>
